// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const deleteStatePermissionsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  state_id: z.number().int().describe("State ID"),
  id: z.number().int().describe("State permission ID (all permissions for the state are deleted regardless of ID)"),
});

export const deleteStatePermissionsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description State permissions deleted successfully
 */
export const deleteStatePermissions200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const deleteStatePermissions401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const deleteStatePermissionsMutationResponseSchema = z.lazy(() => deleteStatePermissions200Schema);
